var React = require('react');

function XRound (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M21.973 21.967a74.99 74.99 0 0 1 106.054 0A75.02 75.02 0 0 1 150 75a75.02 75.02 0 0 1-21.973 53.033 74.99 74.99 0 0 1-106.054 0A75.022 75.022 0 0 1 0 75a75.022 75.022 0 0 1 21.973-53.033Zm90.42 12.533L82.611 68.798h-.002L115 115.5H91.178L69.366 84.05 42.058 115.5H35l31.233-35.967L35 34.5h23.822l20.654 29.78 25.859-29.78h7.058ZM69.78 75.446l3.164 4.484v.002l21.554 30.544h10.841L78.925 73.045l-3.164-4.485-20.32-28.796h-10.84L69.78 75.446Z","clipRule":"evenodd"}));
}

XRound.defaultProps = {"fill":"currentColor","viewBox":"0 0 150 150"};

module.exports = XRound;

XRound.default = XRound;
